module.exports = __webpack_public_path__ + "img/overSea.e5815d60.jpg";